import { Button } from "reactstrap";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import styles from "./index.module.scss";
import deleteButtonIcon from "../../../../assets/images/delete-button.svg";
import { useState } from 'react';
import ConfirmModal from '../ActionsModal/ConfirmModal';

interface EditHeaderProps {
    createNew: boolean;
    hasChanges?: boolean;
    hasDelete?: boolean;
    title: string;
    subTitle: string;
    handleGoBack: () => void;
    handleSave: () => void;  
    handleDelete: () => void;
}

const EditHeader = ({ createNew, hasChanges = false, hasDelete = true, title, subTitle, handleGoBack, handleSave, handleDelete }: EditHeaderProps) => {
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

    const closeModal = (e: React.MouseEvent) => {
        e.stopPropagation();
        setShowDeleteConfirm(false);
    };

    const showConfirmDelete = (e: React.MouseEvent) => {
        e.stopPropagation();
        setShowDeleteConfirm(true);
    };

    const handleConfirmDelete = (e: React.MouseEvent) => {
        e.stopPropagation();
        handleDelete();
        closeModal(e);
    };

    return (
        <div className={styles.header}>
            <div className={styles.headerText}>
                <Button className={styles.backButton} onClick={handleGoBack}>
                    <ArrowBackIcon />
                </Button>
                <div>
                    <h1 className={styles.headerTitleText}>{createNew ? `New ${title}` : `Edit ${title}`}</h1>
                    <h2 className={styles.headerSubTitle}>{`Here you can set up ${title} and its ${subTitle}`}</h2>
                </div>
            </div>
            <div className={styles.headerButtons}>
                {(!createNew && hasDelete) && (
                    <Button className={styles.deleteButton} onClick={showConfirmDelete}>
                        <img src={deleteButtonIcon} alt="Delete Volume" />
                    </Button>
                )}
                <Button className={styles.saveButton} onClick={handleSave} disabled={!hasChanges}>
                    Save
                </Button>
            </div>
            {showDeleteConfirm && (
                <ConfirmModal
                    onCancel={closeModal}
                    onConfirm={handleConfirmDelete}
                />
            )}
        </div>
    )
}

export default EditHeader;